import { Component, HostBinding, Input } from "@angular/core";
import "./formDetails.component.scss";

@Component({
    selector: "form-details",
    template: require("./formDetails.component.html")
})
export class FormDetailsComponent {
    @Input() formTitle: string;
    @Input() subtitle: string;
    @Input() removeContentPadding: boolean;
    @Input() transparent: boolean;
    @HostBinding("class.disabled") @Input() disabled: boolean;

    constructor() {
    }
}
